import { render, staticRenderFns } from "./DatesDialog.vue?vue&type=template&id=5ae11d5c&scoped=true&"
import script from "./DatesDialog.vue?vue&type=script&lang=js&"
export * from "./DatesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae11d5c",
  null
  
)

export default component.exports